import { GET_ORG_GENERAL_SETTINGS, UPDATE_ORG_GENERAL_SETTINGS } from '../../types'

const initialState = {
  general: {
    accountName: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    logoKey: '',
    primaryColor: null,
    secondaryColor: null,
    imageKey: null,
    imagePath: null
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ORG_GENERAL_SETTINGS: return {
      ...state,
      general: action.payload
    }
    case UPDATE_ORG_GENERAL_SETTINGS: return {
      ...state,
      general: action.payload
    }
    default: return { ...state }
  }
}
